// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { FEATURE_FLAGS_SERVICE_ENDPOINT } from './constants/feature-flags.service.constants';
// Types
import { FeatureFlagType } from 'types/feature-flag.type';

const fetchFeatureFlagsInformationService = async (): Promise<
  [FeatureFlagType[] | { [key: string]: never }, Response]
> => apiUtils.get(FEATURE_FLAGS_SERVICE_ENDPOINT);

export { fetchFeatureFlagsInformationService };
